var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"font-md link-style d-inline-block",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openShareModal.apply(null, arguments)}}},[_c('i',{staticClass:"material-icons"},[_vm._v("share")])])}
var staticRenderFns = []

export { render, staticRenderFns }